var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9509 11.3281V10.6585H12.6116V11.3281H13.2812H13.9509ZM12.6116 13.3929C12.6116 13.7627 12.9114 14.0625 13.2812 14.0625C13.6511 14.0625 13.9509 13.7627 13.9509 13.3929H13.2812H12.6116ZM13.2812 11.3281H12.6116V13.3929H13.2812H13.9509V11.3281H13.2812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79492 13.3928H22.7681",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79492 13.3928V18.0803",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 13.3928V18.0803",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7676 13.3928V18.0803",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33929 17.4108H6.25C6.99219 17.4108 7.58928 18.0079 7.58928 18.7501V23.6608C7.58928 24.403 6.99219 25.0001 6.25 25.0001H1.33929C0.597098 25.0001 0 24.403 0 23.6608V18.7501C0 18.0079 0.597098 17.4108 1.33929 17.4108ZM1.67411 21.0938L2.45536 20.3126L3.45982 21.317L5.24554 19.5313L6.02679 20.3126L3.45982 22.8795L1.67411 21.0938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8256 17.4108H15.7363C16.4785 17.4108 17.0756 18.0079 17.0756 18.7501V23.6608C17.0756 24.403 16.4785 25.0001 15.7363 25.0001H10.8256C10.0834 25.0001 9.48633 24.403 9.48633 23.6608V18.7501C9.48633 18.0079 10.0834 17.4108 10.8256 17.4108ZM11.1604 21.0938L11.9417 20.3126L12.9461 21.317L14.7319 19.5313L15.5131 20.3126L12.9461 22.8795L11.1604 21.0938Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3124 17.4108H25.2231C25.9653 17.4108 26.5624 18.0079 26.5624 18.7501V23.6608C26.5624 24.403 25.9653 25.0001 25.2231 25.0001H20.3124C19.5702 25.0001 18.9731 24.403 18.9731 23.6608V18.7501C18.9731 18.0079 19.5702 17.4108 20.3124 17.4108ZM20.8705 19.7545L21.6517 18.9733L22.7678 20.0893L23.8839 18.9733L24.6651 19.7545L23.549 20.8706L24.6651 21.9867L23.8839 22.7679L22.7678 21.6518L21.6517 22.7679L20.8705 21.9867L21.9865 20.8706L20.8705 19.7545Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2644 0C11.9367 0 10.8618 1.07484 10.8618 2.40258C10.8618 3.73032 11.9367 4.80516 13.2644 4.80516C14.5921 4.80516 15.667 3.73032 15.667 2.40258C15.667 1.07484 14.5921 0 13.2644 0Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2002 5.08337H12.3287C10.4446 5.08337 8.91455 6.61344 8.91455 8.49756V9.88853C8.91455 10.1035 9.07894 10.2679 9.29391 10.2679H17.2351C17.45 10.2679 17.6144 10.1035 17.6144 9.88853V8.49756C17.6144 6.61344 16.0843 5.08337 14.2002 5.08337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/masterIcon.5539a2e70b8338a2cbd6fbc66dec2f07.svg";
export { ForwardRef as ReactComponent };